<template>
  <div :class="{ 'is-loading': selectLoading }">
    <v-container v-if="type === 'select' || (type === 'unselect' && !productsSwitch)">
      <v-row>
        <div class="col-5 text-center">
          <v-dialog v-if="itemData.embeds.product_image_url" v-model="dialog" width="300">
            <template v-slot:activator="{ on, attrs }">
              <img
                v-bind="attrs"
                v-on="on"
                loading="lazy"
                :src="itemData.embeds.product_image_url"
                :alt="itemData.attributes.name.ces"
                class="product-image w-100"
              />
            </template>

            <v-card>
              <img
                loading="lazy"
                :src="itemData.embeds.product_image_url"
                :alt="itemData.attributes.name.ces"
                class="w-100"
              />
            </v-card>
          </v-dialog>
          <svg v-else xmlns="http://www.w3.org/2000/svg" height="150" viewBox="0 0 60 60">
            <title>image-placeholder</title>
            <rect fill="#efeeee" width="60" height="60" />
            <path
              fill="#fff"
              d="M41.5,19.38h-23A2.65,2.65,0,0,0,15.85,22V38a2.65,2.65,0,0,0,2.65,2.66h23A2.65,2.65,0,0,0,44.15,38V22A2.65,2.65,0,0,0,41.5,19.38ZM42.38,38a.88.88,0,0,1-.88.89h-23a.88.88,0,0,1-.88-.89V22a.88.88,0,0,1,.88-.89h23a.88.88,0,0,1,.88.89ZM22,28.67a3.1,3.1,0,1,0-3.1-3.09A3.09,3.09,0,0,0,22,28.67Zm0-4.42a1.33,1.33,0,1,1-1.33,1.33A1.34,1.34,0,0,1,22,24.25Zm11.44,1.27-5.25,5.26-1.71-1.72a1.33,1.33,0,0,0-1.88,0l-4.87,4.87a1.32,1.32,0,0,0-.39.94v1.54a.67.67,0,0,0,.67.67H40a.67.67,0,0,0,.67-.67V31.33a1.33,1.33,0,0,0-.39-.94l-4.87-4.87A1.35,1.35,0,0,0,33.48,25.52Zm5.37,9.79H21.15v-.26l4.43-4.42,2.65,2.65,6.19-6.19,4.43,4.42Z"
            />
          </svg>
        </div>
        <div class="col-7">
          <v-card-title class="pa-0 color-primary">{{ itemData.attributes.order_id }}</v-card-title>
          <v-card-title class="px-0 pt-0 color-black">{{ itemData.attributes.sku }}</v-card-title>
          <v-card-text class="px-0"
            >{{ itemData.attributes.name.ces }}
            <span
              class="color-primary"
              :class="itemData.attributes.amount > 1 ? 'pa-1 amber color-red font-weight-bold' : ''"
              >({{ itemData.attributes.amount }}x)</span
            ></v-card-text
          >
          <v-btn
            v-if="type === 'select'"
            @click="
              $emit('change-found', itemData.attributes.id);
              isLoading = true;
            "
            color="primary"
            ><v-icon color="white" class="mr-4">$vuetify.icons.check</v-icon
            >{{ $vuetify.lang.t(`$vuetify.searching.check`) }}</v-btn
          >
          <v-btn
            v-if="type === 'unselect'"
            @click="
              $emit('change-found', itemData.attributes.id);
              isLoading = false;
            "
            color="green"
            dark
            ><v-icon color="white" class="mr-4">$vuetify.icons.check</v-icon
            >{{ $vuetify.lang.t(`$vuetify.searching.uncheck`) }}</v-btn
          >
        </div>
      </v-row>
    </v-container>
    <v-divider v-if="type === 'select' || (type === 'unselect' && !productsSwitch)" />
  </div>
</template>

<script>
export default {
  name: 'SearchedProduct',

  props: {
    type: String,
    itemData: Object,
    productsSwitch: Boolean,
  },

  data() {
    return {
      isLoading: false,
    };
  },

  computed: {
    selectLoading() {
      return this.isLoading && this.productsSwitch && this.type === 'select';
    },
  },
};
</script>

<style scoped>
.is-loading {
  opacity: 0;
  transition: opacity 2s;
}

.product-image {
  max-height: 176px;
  object-fit: contain;
}
</style>
